import { FormControl, MenuItem, OutlinedInput, Select, useTheme } from '@mui/material'
import React from 'react'
import { EmailMessageType, EventRepetitionReminderMode } from '../../services/api/sharedTypes/Email'
import { convertEmailMessageTypeToString, convertEventRepetitionReminderModeToString } from '../../utils/email-utils'

interface EventRepetitionReminderModeSelectProps {
    value: EventRepetitionReminderMode
    onChange: (value: EventRepetitionReminderMode) => void
}

const EventRepetitionReminderModeSelect: React.FC<EventRepetitionReminderModeSelectProps> = ({
    value,
    onChange,
}: EventRepetitionReminderModeSelectProps) => {
    const theme = useTheme()
    return (
        <FormControl size='small' sx={{ mr: 2, flexShrink: 0 }}>
            <Select
                value={value}
                onChange={(e) => onChange(e.target.value as EventRepetitionReminderMode)}
                input={<OutlinedInput style={{ background: theme.palette.customBackground.default, maxHeight: 36 }} />}
                sx={{
                    minWidth: 130,
                    color: value === EventRepetitionReminderMode.Disabled ? 'text.secondary' : 'text.primary',
                }}
                inputProps={{ 'aria-label': convertEmailMessageTypeToString(EmailMessageType.RemindEventRepetition) }}
            >
                <MenuItem value={EventRepetitionReminderMode.Disabled}>
                    {convertEventRepetitionReminderModeToString(EventRepetitionReminderMode.Disabled)}
                </MenuItem>
                <MenuItem value={EventRepetitionReminderMode.Once}>
                    {convertEventRepetitionReminderModeToString(EventRepetitionReminderMode.Once)}
                </MenuItem>
                <MenuItem value={EventRepetitionReminderMode.EveryYear}>
                    {convertEventRepetitionReminderModeToString(EventRepetitionReminderMode.EveryYear)}
                </MenuItem>
            </Select>
        </FormControl>
    )
}

export default EventRepetitionReminderModeSelect
